import { getProductVerticalAndTypeByProductHandler } from '../application/get-product-vertical-and-type-by-product';

export const getProductVerticalAndTypeByProduct = getProductVerticalAndTypeByProductHandler();
